import script from "./CameraRightPane.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraRightPane.vue?vue&type=script&setup=true&lang=js"

import "./CameraRightPane.vue?vue&type=style&index=0&id=fe545828&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe545828"]])

export default __exports__